import React from 'react';
import { Section, FadeIn, StaggerContainer, StaggerItem } from './ui';
import { BookOpen, Zap, Apple, Activity, CalendarDays, NotebookPen, ShoppingBasket, ClipboardCheck } from 'lucide-react';
export const DetailsSection = () => {
  const chapters = [{
    icon: <BookOpen className="w-6 h-6 text-gold" data-id="element-59" />,
    label: 'Capítulo 1',
    title: 'El Mito del Sueño',
    desc: 'Por qué dormir más no es suficiente.'
  }, {
    icon: <Zap className="w-6 h-6 text-gold" data-id="element-60" />,
    label: 'Capítulo 2',
    title: 'El Interruptor de Energía',
    desc: 'Cómo reactivar tu vitalidad hormonal.'
  }, {
    icon: <Apple className="w-6 h-6 text-gold" data-id="element-61" />,
    label: 'Capítulo 3',
    title: 'Nutrición Sin Estrés',
    desc: 'Qué comer y qué evitar en esta etapa.'
  }, {
    icon: <Activity className="w-6 h-6 text-gold" data-id="element-62" />,
    label: 'Capítulo 4',
    title: 'Movimiento Inteligente',
    desc: 'Ejercicio que activa sin agotar.'
  }, {
    icon: <CalendarDays className="w-6 h-6 text-gold" data-id="element-63" />,
    label: 'Capítulo 5',
    title: 'El Plan de 21 Días',
    desc: 'Tu hoja de ruta día a día.'
  }];
  const tools = [{
    icon: <NotebookPen className="w-6 h-6 text-sage" data-id="element-64" />,
    label: 'Herramienta 1',
    title: 'Diario de Energía',
    desc: 'Registro diario de progreso.'
  }, {
    icon: <ShoppingBasket className="w-6 h-6 text-sage" data-id="element-65" />,
    label: 'Herramienta 2',
    title: 'Lista de Compras',
    desc: 'Todo lo que necesitas en una sola página.'
  }, {
    icon: <ClipboardCheck className="w-6 h-6 text-sage" data-id="element-66" />,
    label: 'Herramienta 3',
    title: 'Checklist de Sueño',
    desc: 'Para empezar a descansar de verdad.'
  }];
  return <Section bg="bg-white" data-id="element-67">
      <FadeIn data-id="element-68">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-69">
          <span className="text-gold font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-70">
            Lo que obtienes hoy
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-71">
            Plan de 21 Días de{' '}
            <span className="text-gold italic font-normal" data-id="element-72">
              Vitalidad Menopáusica
            </span>
          </h2>
          <p className="text-lg md:text-xl text-brown-light italic mb-6" data-id="element-73">
            El método de micro-sincronización para la mujer que despertó cansada
            por última vez.
          </p>
          <p className="text-base md:text-lg text-brown-light leading-relaxed" data-id="element-74">
            Un programa completo en formato PDF — diseñado específicamente para
            mujeres de 50+ — que te guía paso a paso durante 21 días para
            recuperar tu energía matutina, reducir la neblina mental y volver a
            sentirte en control de tu cuerpo.
          </p>
        </div>
      </FadeIn>

      {/* Chapters */}
      <FadeIn delay={0.1} data-id="element-75">
        <div className="max-w-5xl mx-auto mb-16" data-id="element-76">
          <h3 className="text-2xl font-bold text-center mb-10" data-id="element-77">
            Los 5 Capítulos del Plan
          </h3>
          <StaggerContainer className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-78">
            {chapters.map((item, i) => <StaggerItem key={i} data-id="element-79">
                <div className="bg-cream-light p-7 rounded-2xl h-full border border-cream-dark hover:shadow-md transition-shadow" data-id="element-80">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-5 shadow-sm" data-id="element-81">
                    {item.icon}
                  </div>
                  <span className="text-xs text-gold font-bold tracking-wider uppercase mb-2 block" data-id="element-82">
                    {item.label}
                  </span>
                  <h4 className="text-lg font-bold mb-2 text-brown" data-id="element-83">
                    {item.title}
                  </h4>
                  <p className="text-brown-light text-sm leading-relaxed" data-id="element-84">
                    {item.desc}
                  </p>
                </div>
              </StaggerItem>)}
          </StaggerContainer>
        </div>
      </FadeIn>

      {/* Tools */}
      <FadeIn delay={0.2} data-id="element-85">
        <div className="max-w-5xl mx-auto" data-id="element-86">
          <h3 className="text-2xl font-bold text-center mb-10" data-id="element-87">
            Tus 3 Herramientas de Implementación
          </h3>
          <StaggerContainer className="grid md:grid-cols-3 gap-6" data-id="element-88">
            {tools.map((item, i) => <StaggerItem key={i} data-id="element-89">
                <div className="bg-sage-light/20 p-7 rounded-2xl h-full border border-sage-light hover:shadow-md transition-shadow" data-id="element-90">
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-5 shadow-sm" data-id="element-91">
                    {item.icon}
                  </div>
                  <span className="text-xs text-sage font-bold tracking-wider uppercase mb-2 block" data-id="element-92">
                    {item.label}
                  </span>
                  <h4 className="text-lg font-bold mb-2 text-brown" data-id="element-93">
                    {item.title}
                  </h4>
                  <p className="text-brown-light text-sm leading-relaxed" data-id="element-94">
                    {item.desc}
                  </p>
                </div>
              </StaggerItem>)}
          </StaggerContainer>
        </div>
      </FadeIn>
    </Section>;
};